import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'stay-mgmt-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  showSpinner = true;

  constructor() {
  }
  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/spinner/spinner.component.ts